/* eslint-disable react/jsx-boolean-value */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext, useState } from 'react';
import { FLIGHT_PAIR } from '../../../../brands/default/content/components/deal';
import ThemeContext from '../../../../providers/ThemeProvider';
import PrimaryButton from '../../../_generic/button/PrimaryButton';
import BookingAlternativeDiff from './BookingAlternativeDiff';
import FlightDetails from './FlightDetails';

export default function FlightPair({
  flights,
  isBasket,
  isAlternative,
  priceDiff,
}) {
  const theme = useContext(ThemeContext);
  const [collapsed, setCollapsed] = useState(true);

  const { selectFlight } = FLIGHT_PAIR;

  const onClickLink = (event) => {
    event.stopPropagation();
    setCollapsed(!collapsed);
  };

  const inboundFlightData = {
    arrival: flights?.departureAirport,
    departure: flights?.arrivalAirport,
    flightData: flights?.inbound || flights?.inboundJourney,
  };

  const outboundFlightData = {
    arrival: flights?.arrivalAirport,
    departure: flights?.departureAirport,
    flightData: flights?.outbound || flights?.outboundJourney,
  };

  return (
    <>
      <div className="bcal-flight-wrapper">
        {isBasket && <p className="bcal-flight-heading">Flight Details</p>}
        <div
          className={classNames('bcal-flight-border', {
            'bcal-flight-border--isAlternative': isAlternative,
            'bcal-flight-border--isBasket': isBasket,
          })}
        >
          <div className="flight-details-summary">
            <FlightDetails
              expanded={false}
              flightDetails={outboundFlightData}
              flightDirection="Outbound"
              seperator={true}
            />
            <FlightDetails
              expanded={false}
              flightDetails={inboundFlightData}
              flightDirection="Inbound"
              seperator={false}
            />
            <div className="dropdown-button__container">
              <button
                className="dropdown-button"
                onClick={(event) => onClickLink(event)}
                type="button"
              >
                {collapsed ? 'More Details' : 'Less Details'}
              </button>
              <div
                className={classNames('flight-details-dropdown', {
                  'content--collapsed': collapsed,
                })}
              >
                <FlightDetails
                  expanded={true}
                  flightDetails={outboundFlightData}
                  flightDirection="Outbound"
                  seperator={false}
                />

                <FlightDetails
                  expanded={true}
                  flightDetails={inboundFlightData}
                  flightDirection="Inbound"
                  seperator={false}
                />
                {isAlternative && !collapsed && (
                  <div className="row align-items-center">
                    <div className="col-4">
                      <BookingAlternativeDiff
                        diff={Number.parseFloat(flights.priceDiff) - priceDiff}
                        isInternal
                      />
                    </div>
                    <div className="col-8 text-right">
                      <PrimaryButton
                        aria-label="select flights"
                        id="button-select-flights"
                      >
                        {selectFlight}
                      </PrimaryButton>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        {isAlternative && collapsed && (
          <BookingAlternativeDiff
            diff={Number.parseFloat(flights.priceDiff) - priceDiff}
          />
        )}
      </div>
      <style jsx>{`
        .bcal-flight-wrapper {
          margin-bottom: 15px;
        }

        .bcal-flight-border {
          border: 2px solid ${theme.commoncolors.greyshade};
          border-radius: 5px;
          padding: 10px;
        }

        @media (min-width: ${theme.breakpoints.lgUp}) {
          .bcal-flight-border--isBasket {
            max-width: 440px;
          }
        }

        .bcal-flight-border--isAlternative {
          border-radius: 0px;
        }

        .flight-details-dropdown {
          display: block;
        }

        .flight-details-dropdown.content--collapsed {
          display: none;
        }

        .alt-expanded-extra {
          text-align: right;
        }

        .dropdown-button__container {
          text-align: center;
        }

        .dropdown-button {
          border: 0;
          background: none;
          color: ${theme.colors.primary};
          font-size: 11px;
          font-weight: bold;
        }

        .dropdown-button:hover {
          text-decoration: underline;
        }

        .bcal-flight-heading {
          color: ${theme.commoncolors.greycharcoal};
          font-size: 14px;
          font-weight: bold;
          margin-top: 10px;
          margin-bottom: 5px;
        }
      `}</style>
    </>
  );
}

FlightPair.propTypes = {
  flights: PropTypes.object,
  isAlternative: PropTypes.bool,
  isBasket: PropTypes.bool,
  priceDiff: PropTypes.number,
};
